import { Component } from "react"

/* Components */
import { InnerLayout } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Helpers */
import { utils } from "../../helpers"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { roomView, kick } from "../../api/Livekit"

/* Sweet alert */
import Swal from "sweetalert2"



/* Widget Studio Room */
class StudioRoom extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            serviceURL: "",
            data: [],
            room: "",
            status: "loading",
        }

        this._timer = null
    }


    /* Open Action */
    open = ({ serviceURL, room }) => {

        this.setState({ visible: true, serviceURL, room }, () => {

            this.load()

            this._timer = setInterval(() => {
                this.load(false)
            }, 15000)

        })
    }


    /* Close */
    close = () => {

        this.setState({ visible: false, serviceURL: "", room: "", status: "loading", data: [] })

        if (this._timer) {
            clearInterval(this._timer)
            this._timer = null
        }

    }

    /* Load Action */
    load = (reload = false) => {

        /* Fields */
        const { serviceURL, room } = this.state

        /* Check Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        roomView(serviceURL, { room }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })
    }

    /* Kick */
    kick = (item) => {

        /* Fields */
        const { serviceURL, room } = this.state

        /* Ask */
        Swal.fire({
            title: t("studio.disableStreamTitle"),
            text: t("studio.disableStreamText"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("studio.disableStreamButton"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {

                kick(serviceURL, { room, identity: item.identity }).then((response) => {
                    if (response.status === 200) {
                        this.load(true)
                        Swal.fire(utils.notification(t("studio.disabledSuccess"), "success"))
                    }
                    else if (response.status === 401 || response.status === 403) {
                        Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                    }
                    else if (response.status === 498) {
                        Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })
            }
        })

    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data } = this.state

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="studio--room-content">
                <div className="studio--room-container">
                    <div className="studio--room-item bold number">#</div>
                    <div className="studio--room-item bold">{t("studio.nameLabel2")}</div>
                    <div className="studio--room-item bold">ID</div>
                    <div className="studio--room-item action"></div>
                </div>
                {data.map((item, index) =>
                    <div key={`${index}`} className="studio--room-container">
                        <div className="studio--room-item number">{index + 1}</div>
                        <div className="studio--room-item bold">{utils.checkValue(item.name, "")}</div>
                        <div className="studio--room-item">{utils.checkValue(item.identity, "")}</div>
                        <div className="studio--room-item action">
                            {!item.isPublisher && <div onClick={() => this.kick(item)} className="studio--room-button">{t("studio.disconnectStream")}</div>}
                        </div>
                    </div>
                )}
            </div>
        )
    }



    render = () => {

        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="studio--room-modal"
                overlayClassName="studio--room-overlay"
                closeTimeoutMS={200}
            >

                <div className="studio--room-modal-header">
                    <h2>{t("studio.participantsTitle")}</h2>
                    <div onClick={() => this.close()} className="studio--room-modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Draw Content */}
                {this._content()}

            </Modal>
        )
    }
}


const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(StudioRoom)